module.exports = __webpack_public_path__ + "static/media/(V)_MG_4943_-_Pro-Natura_-_Moda_Feminina.6e644b13.jpg";